"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _workerthreadspool = require("@lage-run/worker-threads-pool");
const _runners = require("@lage-run/runners");
const _worker_threads = require("worker_threads");
async function setup(options) {
    const { runners } = options;
    const runnerPicker = new _runners.TargetRunnerPicker(runners);
    return {
        options,
        runnerPicker
    };
}
(async ()=>{
    const { runnerPicker } = await setup(_worker_threads.workerData);
    async function run(data, abortSignal) {
        let value = undefined;
        const runner = await runnerPicker.pick(data.target);
        value = await runner.run({
            target: data.target,
            weight: 0,
            abortSignal
        });
        return {
            skipped: false,
            hash: undefined,
            value
        };
    }
    (0, _workerthreadspool.registerWorker)(run);
})();
